<action-box *ngIf="visible"
            class="prices-detail detail-item {{extraStyles}}"
            iconLeft="price"
            textLeft="{{strings.Price}}"
            [iconRight]="settingsIcon"
            iconRightImageSet="primary"
            (onRightIconClick)="onPriceSettingsClick($event)">
  <!-- Customized (iconRight, iconRightImageSet, onRightIconClick) -->
  <gridview *ngIf="contentVisible">
    <gridview-row *ngIf="confPriceValue" classes="row-data align-middle">
      <!-- Customized -->
      <columntemplate class="col">
        <!-- Customized -->
        <div class="price-category"> {{confPriceValue.priceListCategoryName}}</div> <!-- Customized (no stored prices) -->
      </columntemplate>
      <columntemplate class="border-left-0 p-0" size="auto">
        <gridview-row>
          <columntemplate classes="mx-3">
            <!-- Customized -->
            <!--<div *ngIf="showPriceType" class="price-type">{{strings.Current}}</div>--> <!-- Customized (Current) -->
            <div>
              <!-- Customized -->
              <a *ngIf="confPriceValue.effective else expired" class="price-detail" role="button" title="{{strings.Details}}" (click)="onDetailsClick($event, null)">{{confPriceValue.price}}</a>
              <!-- End customized -->
              <ng-template #expired><div><span class="text-danger">{{strings.Expired}}</span></div></ng-template>
            </div>
          </columntemplate>
        </gridview-row>
      </columntemplate>
    </gridview-row>

    <!-- Customized -->
    <gridview-row *ngFor="let localConfPriceValue of confPriceValues" classes="row-data align-middle">
      <columntemplate class="col">
        <div class="price-category"> {{localConfPriceValue.priceListCategoryName}}</div>
      </columntemplate>
      <columntemplate class="border-left-0 p-0 text-right" style="min-width: 180px;" size="auto">
        <gridview-row>
          <columntemplate classes="mx-3">            
            <div>
              <a *ngIf="localConfPriceValue.effective else expired" class="price-detail" role="button" title="{{strings.Details}}" (click)="onDetailsClick($event, localConfPriceValue)">{{localConfPriceValue.price}}</a>
              <ng-template #expired><div><span class="text-danger">{{strings.Expired}}</span></div></ng-template>
            </div>
          </columntemplate>
        </gridview-row>
      </columntemplate>
    </gridview-row>
    <!-- End customization -->

  </gridview>
  <div card-type="control" *ngIf="isPrintView">
    <print-checkbox (onValueChange)="onPrintValueChange($event)"></print-checkbox>
  </div>
</action-box>
<!-- Customization -->
<price-setting-popup></price-setting-popup>
<!-- End customization -->